import React from "react";

export const ResumenHabitaciones = ({ formulario, setFormulario, monedaActiva }) => {
    
const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

    const limpiarSubtotal = (valor) => parseFloat((valor || "").toString().replace(/[^0-9.]/g, "")) || 0; 



   const actualizarCampoRequerimiento = (campo, valor) => {
      setFormulario((prev) => {
          const nuevoValor = parseFloat(valor) || 0; // Convierte a número o usa 0 si no es válido

          // Primero actualizamos el totalHabitaciones
          const nuevosRequerimientos = {
              ...prev.totalHabitaciones,
              [campo]: nuevoValor,
          };

          // Luego calculamos o modificamos totalAB en base a los nuevos valores
          const subtotal = limpiarSubtotal(nuevosRequerimientos.subtotal) || 0;
          const impuestoVenta = limpiarSubtotal(nuevosRequerimientos.impuestoVenta) || 0;
          const impuestoServicio = limpiarSubtotal(nuevosRequerimientos.impuestoServicio) || 0;

          const totalABCalculado = subtotal + impuestoVenta + impuestoServicio;

          return {
              ...prev,
              totalHabitaciones: {
                  ...nuevosRequerimientos,
                  totalAB: formatter.format(totalABCalculado), // Incluimos el totalAB calculado aquí también
              },
          };
      });

   };
    return (
        <div className="invoice-total ms-auto p-3 border rounded shadow-sm">
            <h5 className="text-primary mb-3">Resumen Total {monedaActiva}</h5>
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start">SUB TOTAL {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        disabled
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalHabitaciones.subtotal}
                    />
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start">13% IMP. VENTA {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        onChange={(e) => actualizarCampoRequerimiento("impuestoVenta", e.target.value)}
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalHabitaciones.impuestoVenta}
                    />
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start"> TIP MUCAMA {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        onChange={(e) => actualizarCampoRequerimiento("impuestoServicio", e.target.value)}
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalHabitaciones.impuestoServicio}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-6">
                    <p className="text-dark fw-bold mb-0 text-start">TOTAL HABITACIONES {monedaActiva} </p>
                </div>
                <div className="col-6 text-end">
                    <input
                        disabled
                        style={{
                            minWidth: 120,
                            fontWeight: "bold",
                            textAlign: "right",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ced4da",
                        }}
                        type="text"
                        className="form-control"
                        value={formulario.totalHabitaciones.totalAB}
                    />
                </div>
            </div>
        </div>
    );
};
